export const FAVOURITE_ITEMS_COOKIE_MAX_AGE = null; // forever
export const FAVOURITE_ITEMS_STORAGE_KEY = "favourite-items";
export const FAVOURITE_SHARE_KEY = "id";
export const FAVOURITE_EVENTS_DELIMITER = ";";
